import {connect} from "react-redux";
import LiveUpdate from "./LiveUpdatePanel.jsx";

const mapStateToProps = (state) => {
    return {
        result: state.ranking.result,
        marked: state.markedSportsmen.sportsmen,
        matches: state.calendar.matches
    };
};

const LiveUpdateContainer = connect(
    mapStateToProps
)(LiveUpdate);

export default LiveUpdateContainer